import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as r, useEffect as w } from "react";

var a = function a() {
  var _r = r({
    viewport: "",
    orientation: ""
  }),
      _r2 = _slicedToArray(_r, 2),
      n = _r2[0],
      i = _r2[1];

  return w(function () {
    (function () {
      var e = function e() {
        var t = window.innerWidth <= 480 ? "xsmall" : window.innerWidth <= 640 ? "small" : window.innerWidth < 768 ? "medium" : "large",
            o = window.innerWidth > window.innerHeight ? "landscape" : "portrait";
        i({
          viewport: t,
          orientation: o
        });
      };

      return e(), window.addEventListener("resize", e), function () {
        window.removeEventListener("resize", e);
      };
    })();
  }, []), n;
};

export { a as useViewportInfo };